import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/layout.tsx");
